import { render, staticRenderFns } from "./IntegrationSettings.vue?vue&type=template&id=3fc1e796&scoped=true"
import script from "./IntegrationSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationSettings.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSettings.vue?vue&type=style&index=0&id=3fc1e796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1e796",
  null
  
)

export default component.exports